/*********************************************************
 * Third Components
*********************************************************/
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalBulkDeleteLandmark,
  deleteLandmarkBulk,
  showModalDeleteLandmark
} from 'Redux/actions';

/*********************************************************
 * Modal to delete landmarks elements
*********************************************************/
const ModalBulkDeleteLandmarks = (props) => {

  const { messages } = props

  const dispatch = useDispatch()

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    smodalLandmarkBulkDelete,
    smodalLandmarkDelete,
    landmarkItemsSelected
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);

  /*********************************************************
   * Close modal
  *********************************************************/
  const onHandleClose = (value) => {
    dispatch(showModalBulkDeleteLandmark(value))
    dispatch(showModalDeleteLandmark(value))
  }

  /*********************************************************
   * Event to delete Bulk landmarks
  *********************************************************/
  const onDeleteLandmarks = () => {
    dispatch(deleteLandmarkBulk(landmarkItemsSelected.map(item => { return item.id })))
    onHandleClose(false)
  }

  return (
    <Modal
      title={smodalLandmarkDelete ? messages["realtimemaps_landmarks_delete"] : messages["realtimemaps_landmarks_bulk_delete"]}
      open={smodalLandmarkDelete || smodalLandmarkBulkDelete || false}
      handleClose={() => {
        onHandleClose(false)
      }}
      position="right"
      size="small"
    >
      <ModalBody>
        <div className='modalMLandmark'>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p>{
                landmarkItemsSelected &&
                messages["realtimemaps_landmarks_bulk_delete_detail"].replace('{number}', landmarkItemsSelected.length)}
              </p>
              <p>{messages["realtimemaps_landmarks_bulk_delete_sdetail"]}</p>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div style={{ padding: 10, maxHeight: 300, overflow: 'auto' }}>
                <ul>
                  {
                    landmarkItemsSelected
                    &&
                    landmarkItemsSelected.map((item, index) => {
                      return (
                        <li key={index}>
                          <span>{item.name}</span>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            </Grid>
          </Grid>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          id={'btn-cancel-bulk-delete'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onHandleClose(false)

          }}
          className="btn-gray"
        >
          {messages['realtimemaps_landmarks_groups_delete_cancel']}
        </Button>
        <Button
          id={'btn-save-bulk-delete'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onDeleteLandmarks();
          }}
          className="btn-red"
        >
          {messages['realtimemaps_landmarks_groups_delete_yes']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalBulkDeleteLandmarks